import { Component, Input } from '@angular/core';

import { MediumFacade, MediumGroup } from '@ridango/components';

import { Observable } from 'rxjs';

@Component({
    selector: 'rwidget-medium-type-group-selector',
    templateUrl: './medium-type-group-selector.component.html',
    styleUrls: ['./medium-type-group-selector.component.scss']
})
export class MediumTypeGroupSelectorComponent {
    @Input() locale;
    @Input() step = 0;
    @Input() isEmpty = false;
    mediumGroups$: Observable<MediumGroup[]> = this.mediumFacade.availableMediumGroups$;
    selectedMediumGroup$: Observable<MediumGroup> = this.mediumFacade.selectedMediumGroup$;
    constructor(
        private mediumFacade: MediumFacade
    ) {}

    mediumTypeSelected(mediumGroup) {
        this.mediumFacade.setSelectedMediumGroup(mediumGroup);
    }

}
